import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { Correo } from '../Models/Correo';
@Injectable()
export class CorreoService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService

  ) { }


/**
 * Obtiene todos los correos de la compa;ia
 * @param compania 
 */
  ObtenerCorreros(compania: string): Observable<Correo[]> {

    try {

      let url = this._utiles.getURL("Correo/correoCompania/" + compania );

      return this._http.get(url).map((response: Response) => {
        return <Correo[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

/**
 * Obtiene todos los correos del grupo 
 * @param compania 
 * @param idCodigoGrupo 
 */
  ObtenerCorrerosGrupo(compania: string, idCodigoGrupo): Observable<Correo[]> {

    try {

      let url = this._utiles.getURL("Correo/correoGrupoCorreo/" + compania + '/'+ idCodigoGrupo );

      return this._http.get(url).map((response: Response) => {
        return <Correo[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

/**
 * Obtiene todo el grupo de correo
 */
  ObtenerGrupoCorreo(): Observable<Correo[]> {

    try {

      let url = this._utiles.getURL("Correo/GrupoCorreo" );

      return this._http.get(url).map((response: Response) => {
        return <Correo[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


  public GuardarRegistro(correo: Correo) {

    try {
  
      let params = JSON.stringify(correo);

      let url = this._utiles.getURL("Correo/guardarCorreo");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;


      return this._http.post(url, correo, {headers: headers}).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }

}
